export default () => ({
  //notifications: [],
  unreadNotifications: [],
  readNotifications: [],
  count: 0,
  isLoaded: false,  
  unreadNotificationsCount: 0,
  readNotificationsCount: 0,
});
